<template>
  <v-dialog v-model="dialog" width="580">
    <template v-slot:activator="{on}">
      <v-btn
        flat
        color="error"
        @click="dialog = true"
      >
        Desvincular
      </v-btn>
    </template>

    <v-form v-model="valid">
      <v-card width="580">
        <v-toolbar>
          <v-icon class="mr-2">mdi-alert-octagon</v-icon>
          <v-toolbar-title>Desvincular documento</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout align-center justify-center>
            <img
              class="mr-5"
              src="/static/images/document/shredder-icon.svg"
              alt="Desvincular"
              width="90"
              height="90"
            />

            <v-layout column>
              <span class="body-1 grey--text text--darken-2">
                Digite um despacho para desvincular:
              </span>
              <v-layout class="mt-2" column>
                <div>
                  <v-icon size="16" class="mr-2">mdi-file-document</v-icon>
                  <span class="font-weight-bold grey--text text--darken-3">
                    {{ doc.document_type.name }}
                  </span>
                </div>
                <span class="caption grey--text text--darken-3">
                  DocGo Nº {{ doc.docflow_number }}
                </span>
              </v-layout>
            </v-layout>
          </v-layout>
          <v-textarea
            class="mt-3"
            label="Mensagem do despacho"
            box
            v-model="unlinkDocumentNumber"
            :rules="[validationRules.required]"
          />
          <v-checkbox
            v-model="agreement"
            label="Concordo que essa ação não poderá ser revertida"
            :rules="[v => !!v || 'Campo requerido']"
          />
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              flat
              @click="$emit('closeUnlinkDocumentDialog')"
              :disabled="isLoading"
            >
              Cancelar
            </v-btn>
            <v-btn
              class="white--text"
              color="blue"
              :disabled="!valid"
              @click="confirmUnlink"
              :loading="isLoading"
            >
              Confirmar
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import validationRules from '@/mixins/validation-rules';
import foldersService from '@/services/FoldersService';

export default {
  name: 'UnlinkDocumentDialog',
  props: {
    doc: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      dialog: false,
      agreement: false,
      unlinkDocumentNumber: '',
      valid: false,
      validationRules,
      isLoading: false,
    };
  },
  methods: {
    confirmUnlink() {
      const body = {id: this.doc.id, unlink_document_number: this.unlinkDocumentNumber};

      this.isLoading = true;

      foldersService.unlinkDocument(body)
        .then(() => {
          this.onUnlinkDocumentSuccess();
        })
        .catch((err) => {
          this.onUnlinkDocumentError(err);
        })
        .finally(() => {
          this.isLoading = false;
          this.$emit('closeUnlinkDocumentDialog');
        });
    },
    onUnlinkDocumentSuccess() {
      this.$store.dispatch('getActiveFolder', {id: this.folder.id, loading: false})
        .finally(() => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'info',
            message: 'Documento disvinculado',
            button: {show: true, text: 'Fechar', message: ''},
            messageIcon: 'mdi-information-outline',
            timeout: 6000,
          });
        });
    },
    onUnlinkDocumentError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.message,
        messageIcon: 'mdi-alert-outline',
        button: {show: true, text: 'Fechar', message: ''},
        timeout: 6000,
      });
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/document/show/UnlinkDocumentDialog.vue